import { render, staticRenderFns } from "./SavedRxList.vue?vue&type=template&id=6d04144e&scoped=true"
import script from "./SavedRxList.vue?vue&type=script&lang=ts"
export * from "./SavedRxList.vue?vue&type=script&lang=ts"
import style0 from "./SavedRxList.vue?vue&type=style&index=0&id=6d04144e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d04144e",
  null
  
)

export default component.exports